import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from '../styles/TermsOfServicePage.module.css';
import videoBackground from '../styles/background.mp4';

// Importăm conținutul Termenilor și Condițiilor
import termsOfServiceContent from '../../data/terms';

const TermsOfServicePage = () => {
  const navigate = useNavigate();

  return (
    <div className={styles.TermsOfServicePageContainer}>
      {/* Fundal video */}
      <video className={styles.TermsOfServicePageVideoBackground} autoPlay loop muted>
        <source src={videoBackground} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {/* Header și meniu */}
      <header className={styles.TermsOfServicePageHeaderMenu}>
        <div onClick={() => navigate('/')} className={styles.TermsOfServicePageLogo}>
          Full Trucking Service
        </div>
        <nav>
          <ul>
            <li onClick={() => navigate('/about')}>About Us</li>
            <li onClick={() => navigate('/services')}>Services</li>
            <li onClick={() => navigate('/contact')}>Contact</li>
            <li onClick={() => navigate('/pricing')}>Register</li>
          </ul>
        </nav>
      </header>

      {/* Conținutul principal */}
      <div className={styles.TermsOfServicePageMainContent}>
        <div className={styles.TermsOfServicePagetextSection}>
          <h1>Terms of Service</h1>
          <p><strong>Last Updated: [14.03.2025]</strong></p>

          {/* Afișează conținutul Termenilor și Condițiilor */}
          <div dangerouslySetInnerHTML={{ __html: termsOfServiceContent.replace(/\n/g, '<br/>') }} />
        </div>
      </div>

      {/* Footer */}
      <footer className={styles.TermsOfServicePageFooter}>
        <p onClick={() => navigate('/terms')} className={styles.TermsOfServicePagefooterLink}>
          Terms of Service
        </p>
        <p onClick={() => navigate('/privacy')} className={styles.TermsOfServicePagefooterLink}>
          Privacy Policy
        </p>
        <p onClick={() => navigate('/help')} className={styles.TermsOfServicePagefooterLink}>
          Help
        </p>
      </footer>
    </div>
  );
};

export default TermsOfServicePage;
